export default "__VITE_ASSET__DNq4TbCC__"